{
  "scenery": true,
  "particles": true,
  "music": true,
  "wordDelay": 0.25,
  "tags": ["sint"],
  "lives": 8
}
